module.exports = __webpack_public_path__ + "static/img/far2.cdfe5b5a.png";